<template>
    <v-dialog v-model="dialog" width="420px">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" small icon class="mx-2" color="secondary">
                <v-tooltip bottom color="primary">
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on">mdi-delete</v-icon>
                    </template>
                    <span>delete</span>
                </v-tooltip>
            </v-btn>
        </template>
        <v-card v-if="!loading">
            <div v-if="snackbar?.on">
                <snackbar />
            </div>
            <v-card-title class="text-justify subtitle-2 pt-6 text-pre-wrap">
                Do you really want to delete the resources of the <span class="px-2 secondary--text">{{ this.resource.team.name }}</span> team ?  
            </v-card-title>
            <v-card-text class="text-justify subtitle-2 pt-6 text-pre-wrap">
                <v-icon color="error">mdi-alert</v-icon>
                <span class="px-2 error--text">Attention!</span>
                
                You will automatically delete the finances 
                and the intermediary indicators for this game & team.  
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text class="text-capitalize" @click="closeDialog">
                    No
                </v-btn>
                <v-btn color="error" text class="text-capitalize" :disabled="Boolean(error)" @click="deleteResource">
                    Yes</v-btn>
            </v-card-actions>
        </v-card>
        <div v-else class="text-xs-center">
            <loader></loader>
        </div>
    </v-dialog>
</template>

<script>
import Loader from '../../../layouts/Loader.vue'
import Snackbar from '../../../layouts/Snackbar.vue';

export default {
    props: ['resource'],
    data() {
        return {
            dialog: false,
            error: '',
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        snackbar() {
            return this.$store.getters.snackbar;
        },
        intermediary() {
            
            return this.$store.getters.intermediary_all;
        },
        finances() {
            return this.$store.getters.finances_all;
        }
    },
    methods: {
        closeDialog() {
            this.dialog = false;
        },
        async deleteResource() {
            /* deleting resource + intermediary + finances */
            if (this.resource && this.resource?.id) {
                /*console.log(this.resource)*/
                let id = this.resource.id
                 try {
                    await this.$store.dispatch('deleteResource', id);
                }
                catch (error) {
                    this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `Error during deleting the resources with id ${this.resource.id}: ${error.message}`,
                        timeout: 2000
                    })
                } 
            } else {
                this.$store.dispatch('showSnackbar', {
                    on: true,
                    color: 'secondary',
                    text: `Can't find resources`,
                    timeout: 2000
                })
            }
            const _intermediary = this.intermediary.find((item) => (item.teamId == this.resource?.teamId && item.gameId == this.resource?.gameId && item.round == this.resource?.round));
            
            if (_intermediary && _intermediary.id) {

                /*console.log('intermediary id: ', _intermediary.id)*/ 
                 try {
                    await this.$store.dispatch('deleteIntermediary', _intermediary.id);
                }
                catch (error) {
                    this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `Error during deleting the intermediary with id ${_intermediary.id}: ${error.message}`,
                        timeout: 2000
                    })
                }
            }
            const _finance = this.finances.find((item) => (item.teamId == this.resource?.teamId && item.gameId == this.resource?.gameId && item.round == this.resource?.round));
            
            if (_finance && _finance.id) {
                
                /*console.log('finances id: ', _finance.id)*/ 
                try {
                    await this.$store.dispatch('deleteFinances', _finance.id);
                }
                catch (error) {
                    this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `Error during deleting the finances with id ${_finance.id}: ${error.message}`,
                        timeout: 2000
                    })
                }
            }
        }
    },
    components: { Loader, Snackbar },
}
</script>